import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GroupWord } from 'src/app/group-word/interfaces/GroupWord.interface';
import { GroupWordService } from 'src/app/group-word/service/group-word.service';
import { GroupService } from 'src/app/group/group.service';
import { MembersService } from 'src/app/members/members.service';
import { Group } from 'src/app/shared/interfaces/group.interface';
import { User } from 'src/app/shared/interfaces/user.interface';
import { FrequencyService } from '../services/frequency.service';

@Component({
  selector: 'app-frequency-form',
  templateUrl: './frequency-form.component.html',
  styleUrls: ['./frequency-form.component.css'],
})
export class FrequencyFormComponent implements OnInit {
  group_id: number;
  members: User[] = [];

  frequencyUsers: FormGroup;
  groupWordId;
  groupWord: GroupWord;
  group: Group;
  frequencyId: string;
  form = this.fb.group({
    group_word_id: new FormControl('', Validators.required),
    group_id: new FormControl(null, Validators.required),
    obs: new FormControl(''),
    hour: new FormControl('', Validators.required),
    date: new FormControl('', [Validators.required]),
    visitors: this.fb.array([]),
  });

  constructor(
    private groupService: GroupService,
    private memberService: MembersService,
    private frequencyService: FrequencyService,
    private toast: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private groupWordService: GroupWordService,
    private fb: FormBuilder
  ) {
    /*     const state = this.router.getCurrentNavigation().extras.state;
    if (state) {
      this.groupId = state.groupId;
      this.groupWordId = state.groupWordId;
    } */
    this.addVisitor();
    const frequencyId = this.activatedRoute.snapshot.queryParams.frequencyId;

    this.activatedRoute.queryParams.subscribe((params) => {
      this.form.controls.group_word_id.setValue(params.groupWordId);
      this.groupWordId = params.groupWordId;
      this.group_id = params.groupId;
      this.form.controls.group_id.setValue(params.groupId);
      this.form.updateValueAndValidity();
    });

    if (this.groupWordId && this.group_id) {
      this.setCurrentGroupWord();
      this.setCurrentGroup();
      this.getMembers(this.group_id);
    }
  }

  ngOnInit(): void {}

  setCurrentGroup(): Promise<any> {
    return this.groupService.getById(this.group_id).then((res) => {
      this.group = res;
    });
  }

  getMembers(groupId) {
    this.memberService.getByGroup(groupId).then((res) => {
      this.members = res;

      this.frequencyUsers = new FormGroup({});
      this.members.map((res) => {
        const id = res.id.toString();
        this.frequencyUsers.addControl(id, new FormControl(true));
        this.frequencyUsers.updateValueAndValidity();
      });
      this.form.addControl('frequency_users', this.frequencyUsers);
      this.form.updateValueAndValidity();
    });
  }
  setCurrentGroupWord(): Promise<any> {
    return this.groupWordService.getById(this.groupWordId).then((res) => {
      this.groupWord = res;
    });
  }

  get visitors() {
    return this.form.controls['visitors'] as FormArray;
  }

  addVisitor() {
    const visitors = this.fb.group({
      name: ['', Validators.required],
    });

    this.visitors.push(visitors);
  }

  deleteVisitor(visitorIndex: number) {
    this.visitors.removeAt(visitorIndex);
  }

  save(): Promise<any> {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    return this.frequencyService
      .add(this.form.value)
      .then((res) => {
        this.toast.success(res.message);
        this.form.reset();
        this.router.navigateByUrl('/frequencia');
      })
      .catch((err) => {
        this.toast.error(err.error.message);
      });
  }
}
